import {Injectable} from '@angular/core';
import {ConnectionBackend, Http, RequestOptions, RequestOptionsArgs, Response} from '@angular/http';

import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {authPasswordFlowConfig} from './auth-password-flow.config';
import {getSelectedLanguage, State as AppState} from '../shared/state-management/reducers';

@Injectable()
export class ExtendedHttpService extends Http {
	constructor(_backend: ConnectionBackend, _defaultOptions: RequestOptions, private _store: Store<AppState>) {
		super(_backend, _defaultOptions);
	}

	public post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
		if (url.indexOf('/access_token') !== -1) {
			options = {...options, withCredentials: true};
		}

		if (url.startsWith(authPasswordFlowConfig.issuer)) {
			let selectedLanguage = '';
			this._store.select(getSelectedLanguage).take(1).subscribe(lang => selectedLanguage = lang);
			url += (url.indexOf('?') === -1) ? `?lang=${selectedLanguage}` : `&lang=${selectedLanguage}`;
		}

		return super.post(url, body, options);
	}
}



// WEBPACK FOOTER //
// ./src/app/login/extended-http-service.ts